import moment from "moment";

const isOneTheLastDigit = (num) => {
    if (num === 11) {
        return false;
    };

    const numString = num.toString();


    const lastChar = numString.charAt(numString.length - 1);

    if (lastChar === "1") {
        return true;
    }

    else {
        return false;
    };
};

const getMonthCreatedAtString = (diffInMonths) => {
    const stringMap = {
        1: "pre mesec dana",
        2: "pre dva meseca",
        3: "pre tri meseca",
        4: "pre četiri meseca",
        5: "pre pet meseci",
        6: "pre šest meseci",
        7: "pre sedam meseci",
        8: "pre osam meseci",
        9: "pre devet meseci",
        10: "pre deset meseci",
        11: "pre jedanaest meseci"
    };

    return stringMap[diffInMonths];
};

export const getCreatedAtString = (createdAt) => {
    const now = moment();
    const createdAtMoment = moment(createdAt);

    const diffInMins = now.diff(createdAtMoment, 'minute');
    const diffInHours = now.diff(createdAtMoment, 'hour');
    const diffInDays = now.diff(createdAtMoment, 'day');
    const diffInMonths = now.diff(createdAtMoment, 'month');
    const diffInYears = now.diff(createdAtMoment, 'year');


    const caseNow = (diffInMins === 0);
    const caseZero = (diffInHours === 0);
    const caseOne = (diffInDays === 0);
    const caseTwo = (diffInMonths === 0);
    const caseThree = (diffInYears === 0);

    let finalString = '';

    //Means message is not older then a minute
    if (caseNow) {
        finalString = "Sada";
    }

    //Means difference is in minutes
    else if (caseZero) {
        const suffix = isOneTheLastDigit(diffInMins) ? "minut" : "minuta";

        finalString = `pre ${diffInMins} ${suffix}`;
    }

    //Means diffrence is in hours
    else if (caseOne) {
        const suffix = isOneTheLastDigit(diffInHours) ? "sat" : "sata";

        finalString = `pre ${diffInHours} ${suffix}`;
    }

    //Means difference is in days
    else if (caseTwo) {
        const suffix = isOneTheLastDigit(diffInDays) ? "dan" : "dana";

        finalString = `pre ${diffInDays} ${suffix}`;
    }

    //Means difference is in months
    else if (caseThree) {
        finalString = getMonthCreatedAtString(diffInMonths);
    }

    //Means difference is in years
    else {
        finalString = createdAtMoment.format('DD.MM.YYYY - HH:mm')
    };


    return finalString;
};